<template>
  <el-dialog
    center
    width="1200px"
    :title="`预告标题: ${liveAdvanceNoticeTitle}`"
    :visible.sync="dialogFormVisible"
    @close="resetFrom()"
  >
    <div class="app-container">
      <h2 style="marginbottom: 10px"></h2>
      <div class="header">
        <div class="search" style="search-select;">
          <el-select
            v-model="searchuserId"
            filterable
            placeholder="请选择发布人"
            style="marginright: 10px"
          >
            <el-option label="全部" value="all"> </el-option>
            <el-option
              v-for="item in createrList"
              :key="item.userId"
              :label="item.nickName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
          <el-button icon="el-icon-search" size="small" @click="onSearch"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" size="small" @click="onRefresh"
            >刷新</el-button
          >
        </div>
        <div>
          <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="onAdd"
              v-if="roleList[path].includes('_Live_Add')"
              >新增</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="onRemove"
              v-if="roleList[path].includes('_Live_Delete')"
              >批量删除</el-button
            >
          </el-button-group>
        </div>
      </div>

      <el-table
        v-loading="listLoading"
        height="750"
        :data="tableData"
        element-loading-text="loading"
        border
        fit
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" width="50" label="编号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" width="100" label="动态图片">
          <template slot-scope="scope">
            <img :src="scope.row.photo" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="200"
          label="动态正文"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.contents }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="动态备注">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="edit(scope)"
              v-if="roleList[path].includes('_Live_Update')"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="deleteNews(scope)"
              v-if="roleList[path].includes('_Live_Delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <Pagination ref="Pagination" />

      <!-- <editForm ref="editForm" /> -->

      <el-dialog
        center
        width="600px"
        :title="dialogTitle"
        :visible.sync="editFormVisible"
        append-to-body
        @close="resetFrom('editForm')"
      >
        <el-form :model="editForm" :rules="editRules" ref="editForm">
          <el-form-item
            label="动态图片"
            :label-width="formLabelWidth"
            prop="photo"
          >
            <el-upload
              class="avatar-uploader"
              :action="actionUrl"
              :show-file-list="false"
              :http-request="httpRequest"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="editForm.photo" :src="editForm.photo" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="动态正文"
            :label-width="formLabelWidth"
            prop="contents"
          >
            <el-input
              v-model="editForm.contents"
              type="textarea"
              :rows="4"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="动态备注"
            :label-width="formLabelWidth"
            prop="remark"
          >
            <el-input
              v-model="editForm.remark"
              type="textarea"
              :rows="2"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button
            @click="
              resetFrom('editForm');
              editFormVisible = false;
            "
            >取 消</el-button
          >
          <el-button type="primary" @click="submitEdit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
// const editForm = () => import('./editForm');
import Pagination from '@/components/Pagination';
import {
  getAdvanceContentList,
  getAdvanceContent,
  removeAdvanceContent,
} from '@/api/live.js';
import { getAllUsers } from '@/api/allUser.js';
import { formData, formRules } from './form.js';
import {
  liveUpload,
  editAdvanceContent,
  addAdvanceContent,
} from '@/api/live.js';

import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination,
  },
  inject: ['reload'],

  data() {
    return {
      dialogTitle: '',
      editFormVisible: false,
      actionUrl: '',
      editForm: { ...formData },
      editRules: formRules,
      formLabelWidth: '120px',
      path: '',
      listLoading: false,
      tableData: [],
      createrList: [],
      liveAdvanceNoticeId: '',
      liveAdvanceNoticeTitle: '',
      liveAdvanceContentId: '',
      searchuserId: '',
      pageIndex: 1,
      pageSize: 10,
      multipleSelection: [],
      houseData: [],
      selectValue: '',
      selectLabel: '',
      dialogFormVisible: false,
    };
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');

    this.path = arr[arr.length - 1].split('?')[0];
    // console.log(this.path, 'lalal', this.roleList);
  },
  mounted() {
    // this.liveAdvanceNoticeId = this.$route.query.id;
    // this.liveAdvanceNoticeTitle = this.$route.query.title;
    // this.getList();
  },
  watch: {
    paginObj: 'getList',
  },
  methods: {
    async getList() {
      this.listLoading = true;

      await getAdvanceContentList({
        liveAdvanceNoticeId: this.liveAdvanceNoticeId,
        userId: this.searchuserId,
        //name: this.formInline.name,
        pageIndex: this.paginObj.pageIndex,
        pageSize: this.paginObj.pageSize,
      }).then((res) => {
        this.tableData = res.data.dataList;
        this.listLoading = false;
        this.pageIndex = res.data.pageIndex;
        this.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageIndex = res.data.pageIndex;
        this.$refs.Pagination.pageSize = res.data.pageSize;
        this.$refs.Pagination.totalCount = res.data.totalCount;
      });
      try {
        await getAllUsers().then((res) => {
          this.createrList = res.data;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //搜索
    onSearch() {
      if (this.searchuserId === 'all') {
        this.searchuserId = '';
      }
      this.getList();
    },
    //刷新
    onRefresh() {
      this.getList();
    },
    //新增
    onAdd() {
      this.dialogTitle = '新增预告动态';
      this.editFormVisible = true;
    },

    //编辑
    edit(scope) {
      this.dialogTitle = '编辑预告动态';
      this.editFormVisible = true;
      this.liveAdvanceNoticeId = scope.row.liveAdvanceNoticeId;
      this.liveAdvanceContentId = scope.row.liveAdvanceContentId;
      getAdvanceContent(scope.row.liveAdvanceContentId).then((res) => {
        this.editForm = res.data;
      });
    },
    //批量删除
    onRemove() {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.liveAdvanceContentId);
      });
      this.funcRemove(checkIds);
    },
    //单条删除
    deleteNews(scope) {
      let checkIds = [];
      checkIds.push(scope.row.liveAdvanceContentId);
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0) {
          return this.$message.error('请选择要删除的数据！');
        }
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await removeAdvanceContent(checkIds).then((res) => {
              if (res.code === 200) {
                this.getList();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
    resetFrom() {
      this.editForm = {};
    },
    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M; */
      return isJPG;
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        liveUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            _this.$set(_this.editForm, 'photo', res.data.absoluteFileUrl);
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },

    async submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');

          this.editForm.liveAdvanceNoticeId = this.liveAdvanceNoticeId;

          if (this.liveAdvanceContentId != '') {
            await editAdvanceContent(this.liveAdvanceContentId, {
              ...this.editForm,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');
              } else {
                this.$message.success('编辑失败!');
                return;
              }
            });
          } else {
            await addAdvanceContent({ ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('添加成功!');
              } else {
                this.$message.success('添加失败!');
                return;
              }
            });
          }
          this.editFormVisible = false;
          this.editForm = {};
          this.getList();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }
}
</style>
